import { UseQueryOptions } from '@tanstack/react-query';
import { SenderProfile } from 'domains/content/types';
import { CuredApiPaths } from 'models/enums';
import { PathWithID } from 'models/types';
import useQuery from '../useQuery';
import QueryKeys from './keys';

const useSenderProfile = (senderProfileId: number, reactQueryOptions?: UseQueryOptions<SenderProfile, Error>) =>
    useQuery<SenderProfile>(
        QueryKeys.SENDER_PROFILE_ID(senderProfileId),
        new PathWithID(CuredApiPaths.SENDER_PROFILES, senderProfileId),
        reactQueryOptions
    );

export default useSenderProfile;
